'use client';

import React, { useMemo } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';

export const BlockRuntimeStateContext = createContext<
  | {
      data?: Record<string, Record<string, unknown>>;
      runTimeBlockKey?: string;
    }
  | undefined
>(undefined);

export const useBlockRuntimeData = () => {
  const data = useContextSelector(BlockRuntimeStateContext, (context) => context?.data);
  return { data };
};

export const useRuntimeBlockKey = () => {
  const runTimeBlockKey = useContextSelector(
    BlockRuntimeStateContext,
    (context) => context?.runTimeBlockKey,
  );
  return runTimeBlockKey;
};

export function BlockRuntimeStateContextProvider({
  data,
  runTimeBlockKey,
  children,
}: {
  data?: Record<string, Record<string, unknown>>;
  runTimeBlockKey?: string;
  children: React.ReactNode;
}) {
  const value = useMemo(
    () => ({
      data,
      runTimeBlockKey,
    }),
    [data, runTimeBlockKey],
  );

  return (
    <BlockRuntimeStateContext.Provider value={value}>{children}</BlockRuntimeStateContext.Provider>
  );
}

// this ResetBlockRuntimeStateProvider is used to reset the access of parent block runtime in child block
// the use case of this is that when we render a Block that renders InterfaceResourceProvider(or renders a page in simple terms) nested inside Repeatable, we don't want the child blocks of the new page to consider themselves as repeatable runtime block
export function ResetBlockRuntimeStateProvider({ children }: { children: React.ReactNode }) {
  return (
    <BlockRuntimeStateContext.Provider value={undefined}>
      {children}
    </BlockRuntimeStateContext.Provider>
  );
}
